// extracted by mini-css-extract-plugin
export var root = "x_tj";
export var wrapper = "x_tk";
export var image = "x_tl d_t d_w d_T";
export var crop = "x_tm";
export var round = "x_tn";
export var fixedHeight = "x_tp";